export default {
  items: (state) => state.data.data || [],
  pagination: (state) => state.data,
  options: (state) => state.options,
};
